import React from 'react';
import Link from 'components/link';
import Icon from 'components/icon';
import { classNames } from 'utils';

export default class SettingsContainer extends React.PureComponent {
  navigation = [
    [
      {
        label: 'Store',
        link: '/settings/general',
        section: 'general',
        icon: 'store',
      },
      {
        label: 'Products',
        link: '/settings/products',
        section: 'products',
        icon: 'cubes',
      },
      {
        label: 'Customers',
        link: '/settings/customers',
        section: 'customers',
        icon: 'users',
      },
      {
        label: 'Orders',
        link: '/settings/orders',
        section: 'orders',
        icon: 'shopping-cart',
      },
      {
        label: 'Subscriptions',
        link: '/settings/subscriptions',
        section: 'subscriptions',
        icon: 'rotate',
      },
      {
        label: 'Payments',
        link: '/settings/payments',
        section: 'payments',
        icon: 'credit-card',
      },
      {
        label: 'Discounts',
        link: '/settings/discounts',
        section: 'discounts',
        icon: 'tag',
      },
      {
        label: 'Shipping',
        link: '/settings/shipping',
        section: 'shipping',
        icon: 'truck',
      },
      {
        label: 'Taxes',
        link: '/settings/taxes',
        section: 'taxes',
        icon: 'percent',
      },
      {
        label: 'Gift cards',
        link: '/settings/giftcards',
        section: 'giftcards',
        icon: 'gift',
      },
      {
        label: 'Notifications',
        link: '/settings/notifications',
        section: 'notifications',
        icon: 'envelope',
      },
    ],
    [
      {
        label: 'Account',
        link: '/settings/account',
        section: 'account',
        icon: 'building',
      },
      {
        label: 'Users',
        link: '/settings/users',
        section: 'users',
        icon: 'user',
      },
    ],
  ];

  render() {
    const { section, children } = this.props;

    return (
      <div className="settings-view-container">
        <div className="view-header detail">
          <div className="view-header-name">Settings</div>
        </div>
        <div className="view-body detail">
          <div className="settings-container">
            <div className="settings-nav">
              {this.navigation.map((group, g) => (
                <div key={g} className="nav-group">
                  <ul className="nav-group-list">
                    {group.map((item, i) => (
                      <li
                        key={i}
                        className={classNames({
                          active: item.section === section,
                        })}
                      >
                        <Link to={item.link}>
                          <span className="icon-id">
                            <Icon fa={item.icon} />
                          </span>
                          {item.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
            <div className="settings-page">{children}</div>
          </div>
        </div>
      </div>
    );
  }
}
